﻿import { $$ } from "@/Utils";
import noUiSlider from "nouislider";
import { Options } from "nouislider";

/**
 * @param slider HtmlElement with an initialized slider
 * @param threshold Minimum proximity (in percentages) to merge tooltips
 * @param separator String joining tooltips
 * source: https://refreshless.com/nouislider/examples/#section-merging-tooltips
 */
function mergeTooltips(slider, threshold: number, separator: string) {
  const tooltips = slider.noUiSlider.getTooltips();
  //const origins = slider.noUiSlider.getOrigins();

  // Move tooltips into the origin element. The default stylesheet handles this.
  //tooltips.forEach((tooltip, index) => {
  //    if (tooltip) {
  //        origins[index].appendChild(tooltip);
  //    }
  //});

  slider.noUiSlider.on("update", (values, handle, unencoded, tap, positions) => {

    const pools = [[]];
    const poolPositions = [[]];
    const poolValues = [[]];
    let atPool = 0;

    // Assign the first tooltip to the first pool, if the tooltip is configured
    if (tooltips[0]) {
      pools[0][0] = 0;
      poolPositions[0][0] = positions[0];
      poolValues[0][0] = values[0];
    }

    for (let i = 1; i < positions.length; i++) {
      if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
        atPool++;
        pools[atPool] = [];
        poolValues[atPool] = [];
        poolPositions[atPool] = [];
      }

      if (tooltips[i]) {
        pools[atPool].push(i);
        poolValues[atPool].push(values[i]);
        poolPositions[atPool].push(positions[i]);
      }
    }

    pools.forEach((pool, poolIndex) => {
      const handlesInPool = pool.length;

      for (let j = 0; j < handlesInPool; j++) {
        const handleNumber = pool[j];

        if (j === handlesInPool - 1) {
          //let offset = 0;

          //poolPositions[poolIndex].forEach(value => {
          //    offset += 1000 - 10 * value;
          //});

          //const direction = isVertical ? "bottom" : "right";
          //const last = isRtl ? 0 : handlesInPool - 1;
          //const lastOffset = 1000 - 10 * poolPositions[poolIndex][last];
          //offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

          // Center this tooltip over the affected handles
          tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
          tooltips[handleNumber].style.display = "block";
          //tooltips[handleNumber].style[direction] = offset + "%";
        } else {
          // Hide this tooltip
          tooltips[handleNumber].style.display = "none";
        }
      }
    });
  });
}

export function initSlider() {
  $$(".range-slider").forEach(x => {
    if(x.classList.contains("noUi-target")) return // Already set up
    const container = x.parentElement;
    const rmin = parseFloat((container.querySelector("input[name=rmin]") as HTMLInputElement).value);
    const rmax = parseFloat((container.querySelector("input[name=rmax]") as HTMLInputElement).value);
    const vmin = parseFloat((container.querySelector("input[name=vmin]") as HTMLInputElement).value);
    const vmax = parseFloat((container.querySelector("input[name=vmax]") as HTMLInputElement).value);
    const allowMin = parseFloat((container.querySelector("input[name=allowMin]") as HTMLInputElement).value);
    const allowMax = parseFloat((container.querySelector("input[name=allowMax]") as HTMLInputElement).value);
    const rstep = parseFloat((container.querySelector("input[name=rstep]") as HTMLInputElement).value);
    const urlTemplate = (container.querySelector("input[name=urltemplate]") as HTMLInputElement).value;
    const filterSubmit = container.querySelector(".submit__filter") as HTMLElement;

    const slider = noUiSlider.create(x, {
      range: {
        'min': [rmin, rstep],
        'max': rmax
      },
      step: 1,
      start: [vmin, vmax],
      // Display colored bars between handles
      connect: true,
      tooltips: true,
      format: {
        to(value) {
            return value.toFixed(-Math.floor(Math.log10(Math.min(rstep || 1, 1))));
        },
        from(value) {
          return parseFloat(value);
        }
      }
    } as Options);

    mergeTooltips(x, 10, " - ");

    slider.on("set", (values, handle) => {
      const min = typeof values[0] === "number" ? values[0] : parseFloat(values[0] as string);
      const max = typeof values[1] === "number" ? values[1] : parseFloat(values[1] as string);
      const val = handle === 0 ? min : max;
      //keelame teatud juhtudel min-kuni-min või max-kuni-max filtreerimise
      if (allowMin === 0 && handle === 1 && val * 1 === rmin) {
        values[1] = rmin + rstep;
        slider.set(values);
        return;
      }
      if (allowMax === 0 && handle === 0 && val * 1 === rmax) {
        values[0] = rmax - rstep;
        slider.set(values);
        return;
      }
      filterSubmit.closest(".submit__filter__wrapper").classList.toggle("submit__filter__wrapper--visible", handle === 0 && val !== vmin || handle === 1 && val !== vmax);

      filterSubmit.setAttribute("href", urlTemplate + "_" + min + "_" + max);
    });
  });
}
